import { config } from '../../../core/config/config';
import { TReportCreate } from '../definitions';

export const createReport = async (token: string, report: TReportCreate) => {
  const response = await fetch(`${config.uri.lp_backend}/reports/analytics`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`
    },
    body: JSON.stringify(report)
  });

  return response.ok;
};
